var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"setup":_vm.setup}},[_c('div',{staticClass:"bg-class"},[_c('video',{staticClass:"bgvid",staticStyle:{"object-fit":"fill"},attrs:{"autoplay":"","loop":"","muted":"","id":"bgvid","poster":require("../../asset/guide.jpg")},domProps:{"muted":true}}),_c('img',{staticClass:"part-img",attrs:{"src":_vm.part}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }